import { useState } from "react";

import Typewriter from "./TypeWriter";
import ArrowRight from "../LogoSVG/ArrowRight";
import HomeImageLogoDesktop from "./HomeImageLogoDesktop";

function HomeDesktop() {
  const [hoverArrow, setHoverArrow] = useState<boolean>(false);

  return (
    <div className="flex flex-row">
      <div className="container mt-[100px] mr-20 mb-8">
        <p className="mb-2 font-medium text-[30px]">Hey, Minh here!</p>
        <p className="mb-6 text-base text-gray-5">A glimpse into me.</p>
        <Typewriter />

        <p className="text-gray-5 mt-6 mb-2 md:w-[630px] mr-4">
          An aspiring software engineer eager to learn and grow alongside
          talented people
        </p>

        {/* <p className="text-gray-5 mb-2 md:w-[560px] mr-4 ">I love macOS!</p> */}

        <p className="text-custom-green mb-2 md:w-[560px] mr-4 ">
          Always open to new opportunities, or simply a chat!
        </p>

        <p className="text-gray-5 mb-4 md:w-[600px] mr-4 ">
          When I'm not at my desk, I am probably playing football, at the gym,
          cooking, or at a local coffee shop :]
        </p>

        {/* <div>
          <button
            className="flex flex-row flex-wrap mt-8 text-custom-green items-center mb-1"
            onMouseEnter={() => setHoverArrow(true)}
            onMouseLeave={() => setHoverArrow(false)}
            onClick={() => {
              window.open("/resume.pdf", "_blank");
            }}
          >
            <div className="mr-2 underline underline-offset-4">
              View Full Résumé (Oct 2024)
            </div>
            <ArrowRight
              isYellow
              className={`transition-transform duration-300 ease-in-out ${
                hoverArrow === true ? "translate-x-3" : ""
              }`}
            />
          </button>
        </div> */}
      </div>


    </div>
  );
}

export default HomeDesktop;
